module.exports = __webpack_public_path__ + "../resources/img/ic-error.d27731db.svg";